import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import {
  capitalizeString,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import {
  POST_GetDocumentManagementDetailByID,
  POST_DocumentManagementInsert,
  POST_DocumentManagementUpdate,
} from "../../../helpers/url_helper";
import { post, postFormData } from "../../../helpers/api_helper";

const AddDocumentManagement = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [documentManagementFilePathset, setDocumentManagementFilePath] =
    useState("");
  const [documentManagementFilePathFile, setDocumentManagementFilePathFile] =
    useState(null);

  const validationSchema = Yup.object().shape({
    DocumentName: Yup.string()
      .trim()
      .required("Document Name is required field"),

    Description: Yup.string().trim().required("Description is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      DocumentManagementIDEncrypted: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",
      ParentDocumentManagementIDEncrypted: "",
      DocumentName: "",
      Description: "",
      DocumentManagementFilePath: "",
      DocumentManagementFilePathURL: "",
      DocumentManagementFileName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      DocumentManagementIDEncrypted,
      ParentDocumentManagementIDEncrypted,
      DocumentManagementFilePath,
      DocumentManagementFilePathURL,
      DocumentManagementFileName,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (
      documentManagementFilePathset == "" &&
      DocumentManagementFilePathURL == ""
    ) {
      formik.setFieldError(
        "DocumentManagementFilePath",
        "Please select a valid Document Management File"
      );
      formik.setFieldTouched("DocumentManagementFilePath", true);
      return false;
    }
    setIsLoading(true);
    let formData = new FormData();

    formData.append(
      "DocumentManagementIDEncrypted",
      DocumentManagementIDEncrypted
    );
    formData.append("DocumentName", values?.DocumentName);

    formData.append(
      "Description",
      values?.Description ? values?.Description : ""
    );
    formData.append(
      "DocumentManagementFilePath",
      documentManagementFilePathset
    );
    formData.append(
      "DocumentManagementFilePathURL",
      values?.DocumentManagementFilePathURL
    );

    formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypt", AuthUser?.BranchIDEncrypt);

    formData.append(
      "CreatedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );
    formData.append(
      "ModifiedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );

    postFormData(
      PrimaryIdParam
        ? POST_DocumentManagementUpdate
        : POST_DocumentManagementInsert,
      formData
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/document-management");
          }, 1000);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (DocumentManagementIDEncrypted) {
      GetDocumentManagementDetail();
    }
  }, []);

  const GetDocumentManagementDetail = () => {
    setIsLoading(true);
    post(POST_GetDocumentManagementDetailByID, {
      DocumentManagementIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadDocumentManagementFilePath = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];

      if (!file) {
        setDocumentManagementFilePath(null);
        setDocumentManagementFilePathFile(null);
        warningMessage("Select valid file!");
      } else {
        setDocumentManagementFilePath(file);
        setDocumentManagementFilePathFile(URL.createObjectURL(file));
      }
    }
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam ? "Edit" : "Add"} Document Management
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={4}>
                    <Field
                      label="Document Name"
                      name="DocumentName"
                      placeholder={"Enter Document Name"}
                      component={CustomInput}
                      required
                      maxLength={2000}
                      autoFocus
                      onChange={(e) => {
                        formik.setFieldValue(
                          "DocumentName",
                          capitalizeString(e)
                        );
                      }}
                    />
                  </Col>

                  <Col lg={4}>
                    <div className="d-flex justify-content-between">
                      <label className="mb-1">
                        Document Management File Path{" "}
                      </label>
                      {DocumentManagementFilePath ? (
                        <Link
                          to="#"
                          className="fs-14"
                          onClick={() => {
                            window.open(DocumentManagementFilePath, "_blank");
                          }}
                        >
                          <i className="fa fa-download"></i> Download
                        </Link>
                      ) : (
                        ""
                      )}
                    </div>
                    <input
                      type="file"
                      id="DocumentManagementFilePath"
                      className="form-control form-control-sm"
                      // accept="image/png, image/gif, image/jpeg,.xls, .xlsx,.doc,.docx,application/pdf"
                      onChange={uploadDocumentManagementFilePath}
                    />
                    {/* <label htmlFor="DocumentManagementFilePath" name=""></label> */}
                    <ErrorMessage
                      name="DocumentManagementFilePath"
                      component="div"
                      className="invalid-feedback animated fadeInUp"
                      style={{ display: "block" }}
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      label="Description"
                      name="Description"
                      placeholder={"Enter Description"}
                      component={CustomTextArea}
                      rows={5}
                      maxLength={2000}
                      required
                    />
                  </Col>
                </Row>

                <hr className="mt-1 mb-2"></hr>
                <button type="submit" className="btn btn-primary btn-sm me-2">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default AddDocumentManagement;
